"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceSummary = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Price = require("b2b-components/theme/components/Price");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
require("./PriceSummary.scss");
const PriceSummary = _ref => {
  let {
    className,
    data,
    priceColumnTitle = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-PriceSummary', className)
  }, priceColumnTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-PriceSummary-PriceColumnTitle"
  }, priceColumnTitle), data.map((_ref2, index) => {
    let {
      label,
      value,
      isAdditional,
      isDiscount,
      isTotal,
      currency = 'CHF',
      taxLabel,
      dataAttributes
    } = _ref2;
    const rowClassNames = (0, _classnames.default)('cds-PriceSummary-Row', {
      'cds-PriceSummary-Row--Additional': isAdditional,
      'cds-PriceSummary-Row--Total': isTotal,
      'cds-PriceSummary-Row--SingleRow': data.length === 1,
      'cds-PriceSummary-Row--Discount': isDiscount
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
      className: rowClassNames,
      key: (0, _key.createKey)(label, index)
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "cds-PriceSummary-Label"
    }, label, ' ', taxLabel && /*#__PURE__*/_react.default.createElement("span", {
      className: "cds-PriceSummary-Label--Tax",
      dangerouslySetInnerHTML: {
        // @ts-ignore
        __html: taxLabel
      }
    })), /*#__PURE__*/_react.default.createElement(_Price.Price, {
      className: "cds-PriceSummary-Price",
      currency: currency,
      price: value,
      styleType: isDiscount ? _Price.PRICE_STYLE_TYPE.discount : undefined
    }));
  }));
};
exports.PriceSummary = PriceSummary;
//# sourceMappingURL=PriceSummary.js.map